<template lang="pug">
    .model-list
        gzzoc-list(v-if="config.name === 'gzzoc'")
</template>

<script>
import GzzocList from './gzzoc/list';
import { mapGetters } from 'vuex';
export default {
    data () {
        return {
        };
    },
    components: {
        GzzocList
    },
    computed: {
        ...mapGetters({
            config: 'config'
        })
    },
    created () {
    },
    methods: {

    }
};
</script>

<style lang="sass" scoped>
    .model-list
        height: 100%
</style>